import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';
import {
  getAdminV1StoresStoreIdCheckouts,
  getAdminV1StoresStoreIdCheckoutsId,
  postAdminV1StoresStoreIdCheckoutsIdSendRecovery,
  type AbandonedCheckout,
  type AbandonedCheckoutDetail,
  type GetAdminV1StoresStoreIdCheckouts200,
} from '@nucleus-commerce/api-client/admin';

/**
 * List params as `listParams` builds them from the route's search: `sort`, the flat filter params
 * (`recovered=false`, `total_gte=5000`), `cursor`, `limit`.
 */
export type AbandonedCheckoutListParams = ListParams;

/** Checkouts that stalled after the shopper gave an email; open ones with an address get a recovery email. */
export const abandonedCheckoutsApi = {
  list: (
    storeId: string,
    params: AbandonedCheckoutListParams,
  ): Promise<GetAdminV1StoresStoreIdCheckouts200> =>
    getAdminV1StoresStoreIdCheckouts({ storeId }, params),
  /** Lines priced from the live cart while open; the converted cart's lines once completed. */
  get: (storeId: string, id: string): Promise<AbandonedCheckoutDetail> =>
    getAdminV1StoresStoreIdCheckoutsId({ storeId, id }),
  sendRecovery: (storeId: string, id: string): Promise<AbandonedCheckout> =>
    postAdminV1StoresStoreIdCheckoutsIdSendRecovery({ storeId, id }),
};
